module.exports = __webpack_public_path__ + "img/AI.a37489f7.jpg";